import { render, staticRenderFns } from "./PanelCompetitionLanguagesForm.vue?vue&type=template&id=4dfe6424&scoped=true&"
import script from "./PanelCompetitionLanguagesForm.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionLanguagesForm.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionLanguagesForm.vue?vue&type=style&index=0&id=4dfe6424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfe6424",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dfe6424')) {
      api.createRecord('4dfe6424', component.options)
    } else {
      api.reload('4dfe6424', component.options)
    }
    module.hot.accept("./PanelCompetitionLanguagesForm.vue?vue&type=template&id=4dfe6424&scoped=true&", function () {
      api.rerender('4dfe6424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelCompetitionLanguagesForm.vue"
export default component.exports